import { getPasswordMessage } from "@ac-expo/utils";
import { z } from "zod";

export const definePasswordRequestSchema = z.object({
  email: z.string().email("Veuillez entrer un email valide"),
});

export const defaultDefinePasswordRequestValues = {
  email: "",
};

export type DefinePasswordRequestForm = z.infer<
  typeof definePasswordRequestSchema
>;

export const definePasswordSchema = z.object({
  token: z.string(),
  password: z.string().superRefine((val, ctx) => {
    if (
      val.length < 8 ||
      !/[a-z]/.test(val) ||
      !/[A-Z]/.test(val) ||
      !/[ !"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]/.test(val) ||
      !/[0-9]/.test(val)
    ) {
      return ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: getPasswordMessage(val),
      });
    }
  }),
});

export const defaultDefinePasswordValues = {
  token: "",
  password: "",
};

export type DefinePasswordForm = z.infer<typeof definePasswordSchema>;
